import { axios } from '@Root/API'

export const getFinanceFundingStaticOptions = () => {
	return axios.get('get-data-for-funding-and-monitoring')
}
